//External Dependencies
import React, { Component } from "react";
//Internal Dependencies
import AsyncComponent from "../../../components/async-component";
import { updateBreadcrumb } from "../../../utils/breadcrumbs";
import PageContent from "../../../components/page-content";
import PageWrap from "../../../components/page-wrap";
import { MappingProvider } from "./context/mapping-context";

//Component
class Mapping extends Component {
    componentDidMount = updateBreadcrumb;

    render() {
        return (
            <PageWrap>
                <PageContent>
                    <MappingProvider>
                        <AsyncComponent component={() => import("./content")} />
                    </MappingProvider>
                </PageContent>
            </PageWrap>
        );
    }
}

export default Mapping;